<mat-icon [fontIcon]="icon()" />
<span bspk-txt="body-small"><ng-content /></span>
